import React from 'react';
import StepProgressComponent from 'pages/AuthenticationInner/StepProgressComponent';
import logo from "../../assets/images/White.png";

const QuestionSlide = () => {
  return (
    <div style={{
      height: '100vh',
      overflowY: 'auto',  
      backgroundColor: '#EAF6FF',
      display: 'flex',
      flexDirection: 'column'
    }}>

      {/* Header Section */}
      <header
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '0px 25px',
          background: 'linear-gradient(to right, #A3E566, #2F80F7)',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
          borderRadius: '0 0 12px 12px',
        }}
      >
        <img
          src={logo}
          alt="Logo"
          style={{
            maxWidth: '200px', 
            height: 'auto', 
          }}
        />
        <h1 style={{
          margin: 0,
          fontSize: '1.6rem',
          fontWeight: '600',
          color: '#fff',
          marginLeft: 'auto' // Push text to the right
        }}>
          Welcome to  Bvo Ai
        </h1>
      </header>

      {/* Progress Stepper */}
      <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <StepProgressComponent />
      </div>

    </div>
  );
};

export default QuestionSlide;
